<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>

    <EditLoading ref="loading"></EditLoading>

  </div>
</template>

<style src="./style.scss" lang="scss"></style>

<script>
import EditLoading from "./common/module/EditLoading";

export default {
  name: 'app',
  provide(){
    return {
      reload:this.reload,
      loginout:this.loginout
    }
  },

  components: {
    EditLoading
  },

  data(){
    return {
      isRouterAlive: true
    }
  },

  metaInfo: {
    title: 'Japan Night',
  },

  created() {
    // if(localStorage.getItem('token') == null){
    //     this.$router.push('/index')
    // }else{
 
    //   // this.$router.push('/dashboard')
    // }
  },

  mounted() {
    window.showLoading = this.$refs.loading.showLoading
    window.hideLoading = this.$refs.loading.hideLoading
  },

  methods:{
    reload(){
      this.isRouterAlive=false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },
    loginout() {
      // localStorage.clear();
      this.$router.push('/merchant_admin');
    }
  },

  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>

<style>
  #nprogress .bar {
    background: #26B4FF !important;
  }

  .pull-left{
    float: left;
  }

  .pull-right{
    float: right;
  }

  .clearfix:after{
    content: "";        
    display: block;        
    height: 0;        
    clear: both;        
    visibility: hidden;    
  }
</style>
